"use strict";

require("core-js/modules/es.promise");

var toIter = require("./toIter.js");

var go1 = require("./go1.js");

var nop = require("./nop.js");

var curry = require("./curry.js");

module.exports = curry(function takeUntil(f, iter) {
  let res = [];
  iter = toIter(iter);
  return function recur() {
    let cur;

    while (!(cur = iter.next()).done) {
      const a = cur.value;
      const b = go1(a, a => (res.push(a), f(a, res)));
      if (b instanceof Promise) return b.then(b => b ? res : recur()).catch(e => e == nop ? recur() : Promise.reject(e));
      if (b) break;
    }

    return res;
  }();
});